<app-alert />
<app-loading-modal />
<app-modal />

<ion-app>
  <ion-router-outlet></ion-router-outlet>
</ion-app>
